import React from "react"


const Error404 = () => (
    <div>Page Not Found</div>
)


export default Error404
